// Chamadas do painel pro Mesa QR. O token vai em cada request porque o app
// não usa interceptor global de axios.
import axios from "axios";

const API = "/api";

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

export const listarMesas = () => axios.get(`${API}/mesa-qr/mesas`, auth());
export const lerConfig = () => axios.get(`${API}/mesa-qr/config`, auth());
export const gravarConfig = (valores) => axios.put(`${API}/mesa-qr/config`, valores, auth());
export const listarChamados = () => axios.get(`${API}/mesa-qr/chamados`, auth());
export const atenderChamado = (mesaId) => axios.post(`${API}/mesa-qr/${mesaId}/atender`, {}, auth());
export const rotacionar = (mesaId) => axios.post(`${API}/mesa-qr/rotacionar`, { mesa_id: mesaId || null }, auth());
export const bloquear = (mesaId, bloqueada) =>
  axios.post(`${API}/mesa-qr/${mesaId}/bloquear`, { bloqueada }, auth());

/** PNG do QR como data URI: a rota é autenticada, então <img src> direto não
 *  funcionaria (a tag não manda o Bearer). */
export async function qrComoDataUri(mesaId) {
  const { data } = await axios.get(`${API}/mesa-qr/${mesaId}/qrcode.png`, {
    ...auth(), responseType: "blob",
  });
  return new Promise((resolve, reject) => {
    const leitor = new FileReader();
    leitor.onloadend = () => resolve(leitor.result);
    leitor.onerror = reject;
    leitor.readAsDataURL(data);
  });
}

// Pessoas da mesa (24/09/2026): o garçom lança cada produto para uma pessoa e
// o caixa cobra por pessoa. Inclui quem entrou pelo QR e quem foi criado aqui.
export const listarPessoas = (mesaId) => axios.get(`${API}/mesa-qr/${mesaId}/pessoas`, auth());
export const criarPessoa = (mesaId, dados) => axios.post(`${API}/mesa-qr/${mesaId}/pessoas`, dados, auth());
// Nova pessoa começa pelo CPF (dono, 25/09/2026): cadastro exato e sugestões enquanto digita
export const clientePorCpf = (cpf) => axios.get(`${API}/clientes/por-cpf/${cpf}`, auth());
export const buscarClientes = (termo) => axios.get(`${API}/clientes/search/${encodeURIComponent(termo)}`, auth());
export const saidaNoCaixa = (mesaId, clienteId, motivo = null) =>
  axios.post(`${API}/mesa-qr/${mesaId}/pessoas/${encodeURIComponent(clienteId)}/saida`, { motivo }, auth());

// QR Code em massa (24/09/2026): o nome da mesa vai gravado no meio do QR;
// baixar a imagem, o PDF dos cartões ou mandar para a impressora do caixa.
export const gravarNomeQr = (mesaId, nome, manterAtual = false) =>
  axios.put(`${API}/mesa-qr/${mesaId}/nome-qr`, { nome, manter_atual: manterAtual }, auth());

/** `mesaIds` vazio = todas as mesas da loja. */
export const imprimirCartoes = (mesaIds) =>
  axios.post(`${API}/mesa-qr/imprimir-cartoes`, { mesa_ids: mesaIds?.length ? mesaIds : null }, auth());

function salvarArquivo(blob, nome) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function baixarPdfCartoes(mesaIds) {
  const { data } = await axios.post(
    `${API}/mesa-qr/cartoes.pdf`,
    { mesa_ids: mesaIds?.length ? mesaIds : null },
    { ...auth(), responseType: "blob" },
  );
  salvarArquivo(data, "qr-codes-mesas.pdf");
}

export async function baixarPngMesa(mesa) {
  const { data } = await axios.get(`${API}/mesa-qr/${mesa.id}/qrcode.png`, {
    ...auth(), responseType: "blob",
  });
  salvarArquivo(data, `qr-${mesa.slug || "mesa"}.png`);
}
